import script from "./table.vue?vue&type=script&setup=true&lang=js"
export * from "./table.vue?vue&type=script&setup=true&lang=js"

import "./table.vue?vue&type=style&index=0&id=17fadc74&lang=css"

const __exports__ = script;

export default __exports__